/* global axios */
import ApiClient from './ApiClient';

class CanalProAPI extends ApiClient {
  constructor() {
    super('canalpro', { accountScoped: true });
  }

  endpoint(resource, ...segments) {
    return [this.baseUrl(), resource, ...segments].join('/');
  }

  credentials(params = {}) {
    return axios.get(this.endpoint('canalpro_credentials'), { params });
  }

  createCredential(payload = {}) {
    return axios.post(this.endpoint('canalpro_credentials'), payload);
  }

  updateCredential(id, payload = {}) {
    return axios.patch(this.endpoint('canalpro_credentials', id), payload);
  }

  deleteCredential(id) {
    return axios.delete(this.endpoint('canalpro_credentials', id));
  }

  validateCredential(id) {
    return axios.post(
      this.endpoint('canalpro_credentials', id, 'validate'),
      {}
    );
  }

  accounts(params = {}) {
    return axios.get(this.endpoint('canalpro_accounts'), { params });
  }

  syncAccounts() {
    return axios.post(this.endpoint('canalpro_accounts', 'sync'), {});
  }

  updateAccount(id, payload = {}) {
    return axios.patch(this.endpoint('canalpro_accounts', id), payload);
  }

  accountUsers(id) {
    return axios.get(this.endpoint('canalpro_accounts', id, 'users'));
  }

  updateAccountUsers(id, payload = {}) {
    return axios.put(this.endpoint('canalpro_accounts', id, 'users'), payload);
  }

  listings(params = {}) {
    return axios.get(this.endpoint('canalpro_listings'), { params });
  }

  liveListings(params = {}) {
    return axios.get(this.endpoint('canalpro_listings', 'live'), { params });
  }

  listing(id) {
    return axios.get(this.endpoint('canalpro_listings', id));
  }

  createListing(payload = {}) {
    return axios.post(this.endpoint('canalpro_listings'), payload);
  }

  createLiveListing(payload = {}) {
    return axios.post(this.endpoint('canalpro_listings', 'live'), payload);
  }

  updateListing(id, payload = {}) {
    return axios.patch(this.endpoint('canalpro_listings', id), payload);
  }

  updateLiveListing(id, payload = {}) {
    return axios.patch(this.endpoint('canalpro_listings', id, 'live'), payload);
  }

  deleteListing(id) {
    return axios.delete(this.endpoint('canalpro_listings', id));
  }

  publishListing(id) {
    return axios.post(this.endpoint('canalpro_listings', id, 'publish'), {});
  }

  unpublishListing(id) {
    return axios.post(this.endpoint('canalpro_listings', id, 'unpublish'), {});
  }

  syncListing(id) {
    return axios.post(this.endpoint('canalpro_listings', id, 'sync'), {});
  }

  updateListingPublicationType(id, publicationType) {
    return axios.patch(
      this.endpoint('canalpro_listings', id, 'publication_type'),
      { publication_type: publicationType }
    );
  }

  uploadListingMedia(file, accountId) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('canalpro_account_id', accountId);

    return axios.post(this.endpoint('canalpro_listing_media'), formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}

export default new CanalProAPI();
